/**
 * The account page's path. It used to be `/settings`, which collided with the
 * agent page's own Settings tab — two different "Settings", both behind a gear
 * icon. `/settings` and `/profile` both still resolve here so existing links
 * and open tabs keep working.
 */
export const ACCOUNT_ROUTE = '/account';

/** Paths that `/account` absorbed, kept as redirects. */
export const ACCOUNT_LEGACY_ROUTES = ['/settings', '/profile'] as const;

/**
 * Top-level destinations reachable from the sidebar. The header hides its back
 * button on these, since there is nowhere above them to go back to.
 *
 * Shared rather than duplicated: Layout and Header each held their own copy of
 * this list, so renaming a route meant editing both, and missing one left a
 * stray back button on the page.
 */
export const SIDEBAR_ROUTES = [
  '/',
  '/home',
  '/billing',
  ACCOUNT_ROUTE,
  '/help',
] as const;

export const isSidebarRoute = (pathname: string): boolean =>
  (SIDEBAR_ROUTES as readonly string[]).includes(pathname);
